// extracted by mini-css-extract-plugin
export default {"container":"UserSessionData_container__U97nk","normalText":"UserSessionData_normalText__JFRMK","horizontalContainer":"UserSessionData_horizontalContainer__GwMIr"};